import { render, staticRenderFns } from "./inventoryTurnoverAnalysisByGoodsList.vue?vue&type=template&id=2d095263&scoped=true&"
import script from "./inventoryTurnoverAnalysisByGoodsList.vue?vue&type=script&lang=js&"
export * from "./inventoryTurnoverAnalysisByGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./inventoryTurnoverAnalysisByGoodsList.vue?vue&type=style&index=0&id=2d095263&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d095263",
  null
  
)

export default component.exports